import pubsub from "@viewlift/pubsub";
var publishIsActive = function (data) {
    //update the active Plan on cta selection
    pubsub.publish('is-active', data);
};
var subscribeIsActive = function (cb) {
    pubsub.subscribe('is-active', cb);
};
var subscribePlansLoaded = function (cb) {
    pubsub.subscribe('plans-loaded', cb);
};
var publishPlansLoaded = function (data) {
    pubsub.publish('plans-loaded', data ? true : false);
};
var subscribeUpdateMonetizationCta = function (cb) {
    // will update the right side cta in case video have some different plans attached to it or in case of login
    pubsub.subscribe('update-monetization-cta', cb);
};
var publishUpdateMonetizationCta = function (data) {
    pubsub.publish('update-monetization-cta', data);
};
var subscribeGetContentEntitlementPlans = function (cb) {
    pubsub.subscribe('fetch-content-entitlement-plans', cb);
};
var publishGetContentEntitlementPlans = function (data) {
    pubsub.publish('fetch-content-entitlement-plans', data);
};
export { publishIsActive, subscribeIsActive, subscribePlansLoaded, publishPlansLoaded, subscribeUpdateMonetizationCta, publishUpdateMonetizationCta, subscribeGetContentEntitlementPlans, publishGetContentEntitlementPlans };
